import { render, staticRenderFns } from "./assign-role.vue?vue&type=template&id=1025e03c&scoped=true"
import script from "./assign-role.vue?vue&type=script&lang=js"
export * from "./assign-role.vue?vue&type=script&lang=js"
import style0 from "./assign-role.vue?vue&type=style&index=0&id=1025e03c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1025e03c",
  null
  
)

export default component.exports